import React from "react";
import { useUserContext } from "context/UserContext";
import TransactionsNewBK from "layouts/BK/transactionsNew";
import TransactionsNewCM from "layouts/CM/transactionsNew";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";

function TransactionsNew() {
  const { roleLevel } = useUserContext() || {};
  const numericRoleLevel = normalizeRoleLevel(roleLevel);
  if (isManagementRoleLevel(numericRoleLevel)) {
    return <TransactionsNewBK />;
  }
  if (numericRoleLevel === 4 || numericRoleLevel === 5) {
    return <TransactionsNewCM />;
  }
  return null;
}

export default TransactionsNew;
